<template>
  <div>
    <ui-modal ref="detalle-recargos-modal" size="auto" id="detalle-recargos-modal" title="Recargos asociados"
              @close="closeModal('detalle-recargos-modal')">
      <div v-if="isLoading" class="loading-container">
        <Loading />
      </div>

      <div v-else class="w-100">
        <div v-if="recharges.length === 0" class="loading-container my-5">
          <h5 class="text-center "> No se encontraron Recargos Asociados</h5>
        </div>

        <div v-else class="recargos-asociados">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <table class="table text-center w-100 table-bordered table-hover">
                  <thead>
                  <tr>
                    <th colspan="9" style="background-color: beige;">Recargos asociados</th>
                  </tr>
                  <tr>
                    <th>Recargo</th>
                    <th>Tipo</th>
                    <th>Desde</th>
                    <th>Hasta</th>
                    <th>POL</th>
                    <th>POD</th>
                    <th>Valor recargo</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(recharge, index) in recharges" :key="index">
                    <td>
                      <span> {{ recharge.recharge_name }}</span>
                    </td>
                    <td>
                      <span>{{ recharge.description }} </span>
                    </td>
                    <td>
                      <span> {{ recharge.from }} </span>
                    </td>
                    <td>
                      <span> {{ recharge.to }}  </span>
                    </td>
                    <td>
                      <span> {{ recharge.pol }}  </span>
                    </td>
                    <td>
                      <span> {{ recharge.pod }}  </span>
                    </td>
                    <td v-if="version !== 2">
                      <span> {{ recharge.public_value_str }} </span>
                    </td>
                    <td v-else>
                      <span> {{ recharge.net_value_str }} </span>
                    </td>
                  </tr>

                  <tr class="table-success">
                    <th colspan="4"></th>
                    <th colspan="2"> TOTALES ORIGEN</th>
                    <th v-if="version !== 2">{{ formatValue(totals.origin_recharges.public) }}</th>
                    <th v-else>{{ formatValue(totals.origin_recharges.net) }}</th>
                  </tr>

                  <tr class="table-success">
                    <th colspan="4"></th>
                    <th colspan="2">TOTALES DESTINO</th>
                    <th v-if="version !== 2">{{ formatValue(totals.destination_recharges.public) }}</th>
                    <th v-else>{{ formatValue(totals.destination_recharges.net) }}</th>
                  </tr>

                  <tr class="table-success">
                    <th colspan="4"></th>
                    <th colspan="2"> TOTALES FLETE</th>
                    <th v-if="version !== 2">{{ formatValue(totals.freight_recharges.public) }}</th>
                    <th v-else>{{ formatValue(totals.freight_recharges.net) }}</th>
                  </tr>

                  </tbody>
                </table>
              </div>

              <div class="col-12">
                <table class="table text-center w-100 table-bordered table-hover">
                  <thead>
                  <tr>
                    <th colspan="8" style="background-color: beige;">Tarifa All In = Ocean Freight + Recargos Flete + Recargos en Origen</th>
                  </tr>
                  <tr>
                    <th style="background-color: ghostwhite;">Desde</th>
                    <th style="background-color: ghostwhite;">Hasta</th>
                    <th style="background-color: ghostwhite;">POL</th>
                    <th style="background-color: ghostwhite;">POD</th>
                    <th style="background-color: ghostwhite;" >T. Pública</th>
                    <th v-if="version !== 2" style="background-color: ghostwhite;">
                      T. Neta
                    </th>
                    <th v-if="version !== 2" style="background-color: ghostwhite;">
                      Descuento
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="table-success">
                    <th style="background-color: ghostwhite;">{{ tariff.from_date }}</th>
                    <th style="background-color: ghostwhite;">{{ tariff.to_date }}</th>
                    <th style="background-color: ghostwhite;">{{ tariff.pol }}</th>
                    <th style="background-color: ghostwhite;">{{ tariff.pod }}</th>
                    <th style="background-color: ghostwhite;">USD {{ formatValue(tariff.public_value) }}</th>
                    <th v-if="version !== 2" style="background-color: ghostwhite;">
                      USD {{ formatValue(tariff.net_value) }}
                    </th>
                    <th v-if="version !== 2" style="background-color: ghostwhite;">
                      USD {{ formatValue(totals.tariff_total.discount) }}
                    </th>
                  </tr>

                  <tr class="table-success">
                    <th colspan="3"></th>
                    <th>TOTAL TARIFA + RECARGOS</th>
                    <th>{{ totals.tariff_total.public_string || ('USD ' + formatValue(totals.tariff_total.public)) }}</th>
                    <th v-if="version !== 2">
                      {{ totals.tariff_total.net_string || ('USD ' + formatValue(totals.tariff_total.net)) }}
                    </th>
                    <th v-if="version !== 2">
                      USD {{ formatValue(totals.tariff_total.discount) }}
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import UiModal from "keen-ui/src/UiModal";
import Loading from "../../../../common/loading.vue";
import VueToastify from "vue-toastify";

Vue.use(VueToastify);

import { getClientDiscountRecharges, getTariffLinesRecharges } from "@/constants/lineas";

export default {
  components: {
    UiModal,
    Loading
  },
  props: {
    id: { type: Number, default: () => 0 },
    version: { type: Number, default: () => 0 }
  },
  data() {
    return {
      tariff: {},
      recharges: [],
      totals: [],
      isLoading: true
    };
  },
  computed: {
    ...mapState("lineas", [
      "showModalCustomerDiscountsRecharges",
      "showModalTariffLinesRecharges"
    ])
  },
  methods: {

    ...mapActions([
      "ActionSetZindexModal"
    ]),

    ...mapActions("lineas", [
      "actionsSetShowModalCustomerDiscountsRecharges",
      "actionsSetShowModalTariffLinesRecharges"
    ]),

    formatValue(value) {
      return value === null || value === undefined ? "-" : value;
    },

    openModal(ref) {

      this.ActionSetZindexModal(true);

      this.$refs[ref].open();

    },

    closeModal(ref) {

      this.actionsSetShowModalCustomerDiscountsRecharges(false);

      this.actionsSetShowModalTariffLinesRecharges(false);

      this.ActionSetZindexModal(false);

      this.$refs[ref].close();

    },

    async getRecharges(id, version) {

      this.isLoading = true;

      let data = {};

      switch (version) {

        case 1:

          data = await getClientDiscountRecharges(id);

          break;

        case 2:

          data = await getTariffLinesRecharges(id);

          break;

      }

      this.tariff = data.tariff;

      this.recharges = data.recharges;

      this.totals = data.totals;

      this.isLoading = false;
    }
  },
  watch: {

    showModalCustomerDiscountsRecharges: async function(_new) {

      if (_new) {

        this.openModal("detalle-recargos-modal");

        await this.getRecharges(this.id, this.version);

      } else {

        this.closeModal("detalle-recargos-modal");

      }

    },

    showModalTariffLinesRecharges: async function(_new) {

      if (_new) {

        this.openModal("detalle-recargos-modal");

        await this.getRecharges(this.id, this.version);

      } else {

        this.closeModal("detalle-recargos-modal");

      }

    }

  }
};
</script>

<style lang="scss" scoped>

#modalVerRecargosAsociados .ui-modal__container {
  width: 83% !important;
}

.loading-container {
  width: 80vw;
}

.recargos-asociados {
  width: 80vw;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 2rem;
  gap: 1rem;

  &__container {
    grid-row: 1/2;
    grid-column: 1/2;
    overflow: auto;

    &-recargos {
      margin-bottom: 20px;

      &-title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
      }

      &-info {
        display: flex;
        flex-direction: column;
        gap: 10px;


        &-item {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          color: #178533;
          border: 1px solid #1785338a;
          padding: 5px 10px;
          border-radius: 5px;
          margin-bottom: 5px;

          &-data {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 16px;
            gap: 20px;
          }

          &-value {
            color: #178533;
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            gap: 3px;
          }
        }
      }
    }
  }

  &__actions {
    grid-row: 2/3;
    grid-column: 1/2;
    display: flex;

    &-values {

      font-size: 18px;

      &-item {
        width: 80px;
        height: 20px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 5px;

        p {
          font-size: 18px;
          margin-top: 15px;
        }
      }
    }

    &-btn {
      width: 10%;
      height: 100%;
    }
  }
}

.text-strong {
  font-weight: bold;
}

.not-found-recharge {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #c5c5c5;
  padding: 5px 10px;
  border-radius: 5px;
  margin-bottom: 5px;
}

.btn__delete {
  margin-right: 10px;
  font-size: 1.2rem;
  color: #dc143c;
  cursor: pointer;
  transition: transform .3s ease-out;

  &:hover {
    transform: scale(1.5);
  }
}
</style>